import * as actionTypes from "../actions/actionTypes";

const initialState = [];
const getExamBoardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_EXAMINATION_BOARDS:
      return {
        boards: action.payload.boards,
      };

    default:
      return state;
  }
};
export default getExamBoardsReducer;
